export default __webpack_public_path__ + "static/media/hht2_ep_14.fbbb9a1e.png";